<template>
    <b-card :class="'main'">
        <h1>{{ $t('pages.admin_report_won.title') }}</h1>

        <AdminProjectsTable />
    </b-card>
</template>
<script>
import AdminProjectsTable from '../../components/Admin/AdminProjectsTable.vue';

export default {
  components: {
    AdminProjectsTable,
  },
  metaInfo() {
    return {
      title: 'Ohanterade projekt',
    }
  },
  data() {
    return {
      api_token: sessionStorage.getItem('api_token') || null
    }
  }
}
</script>